// extracted by mini-css-extract-plugin
export var grid = "_2a-0";
export var span1 = "_2a-2";
export var span10 = "_2a-b";
export var span10L = "_2a-z";
export var span10M = "_2a-n";
export var span10Xl = "_2a-1b";
export var span11 = "_2a-c";
export var span11L = "_2a-10";
export var span11M = "_2a-o";
export var span11Xl = "_2a-1c";
export var span12 = "_2a-d";
export var span12L = "_2a-11";
export var span12M = "_2a-p";
export var span12Xl = "_2a-1d";
export var span1L = "_2a-q";
export var span1M = "_2a-e";
export var span1Xl = "_2a-12";
export var span2 = "_2a-3";
export var span2L = "_2a-r";
export var span2M = "_2a-f";
export var span2Xl = "_2a-13";
export var span3 = "_2a-4";
export var span3L = "_2a-s";
export var span3M = "_2a-g";
export var span3Xl = "_2a-14";
export var span4 = "_2a-5";
export var span4L = "_2a-t";
export var span4M = "_2a-h";
export var span4Xl = "_2a-15";
export var span5 = "_2a-6";
export var span5L = "_2a-u";
export var span5M = "_2a-i";
export var span5Xl = "_2a-16";
export var span6 = "_2a-7";
export var span6L = "_2a-v";
export var span6M = "_2a-j";
export var span6Xl = "_2a-17";
export var span7 = "_2a-8";
export var span7L = "_2a-w";
export var span7M = "_2a-k";
export var span7Xl = "_2a-18";
export var span8 = "_2a-9";
export var span8L = "_2a-x";
export var span8M = "_2a-l";
export var span8Xl = "_2a-19";
export var span9 = "_2a-a";
export var span9L = "_2a-y";
export var span9M = "_2a-m";
export var span9Xl = "_2a-1a";
export var stretch = "_2a-1";